import ProfileNavigate from 'components/ProfileNavigate';
import APP from 'stores/APP';
import { getRedirectUrlConfig } from './helper';

// plaid绑定回调中转
// /transation/plaid/deposit|withdraw/[inapp]?oauth_state_id=xx   其中oauth_state_id为plaid返回内容，其他参数为约定的内容, inapp需要继续跳转到APP内操作
const Plaid: React.FC = () => {
    const { url } = getRedirectUrlConfig(window.location.href, APP.isTiger);

    if (url.startsWith('http')) {
        window.location.href = url;

        return null;
    }

    return <ProfileNavigate to={url} replace />;
};

export default Plaid;
